import React from "react";
import Moment from "moment";
import { Button, TextField, Stack, CircularProgress, Box } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { useFormik } from "formik";
import { REPORTESPORDIA } from "../../../graphql/reporteador";
import { useLazyQuery } from "@apollo/client";
const FrmReportDay = ({ setDatos, setOpenDialog, setTitle }) => {
  const [reporteCobrosPorDia, { loading, error, data }] =
    useLazyQuery(REPORTESPORDIA);
  const formik = useFormik({
    initialValues: {
      fechaTrabajo: "",
    },
    onSubmit: async (inputData) => {
      try {
        const datos = await reporteCobrosPorDia({
          variables: {
            fecha: inputData.fechaTrabajo,
          },
        });
        setDatos(datos.data.reporteCobrosPorDia);
        setOpenDialog(false);
        setTitle(
          `Reporte del día ${Moment(inputData.fechaTrabajo).format(
            "DD-MMMM-YYYY"
          )}`
        );
      } catch (error) {
        console.log(error);
      }
    },
  });

  if (loading)
    return (
      <>
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </>
    );

  //Call Information from the backend
  const handleOpenDialog = () => {
    setOpenDialog(false);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            onChange={(date) => formik.setFieldValue("fechaTrabajo", date)}
            value={formik.values.fechaTrabajo}
            renderInput={(params) => (
              <TextField
                {...params}
                name="fechaTrabajo"
                fullWidth
                variant="standard"
                label="Fecha de Trabajo"
              />
            )}
          />
        </LocalizationProvider>
      </Stack>
      <Stack direction="row" alignItems="center" sx={{ my: 2 }}>
        <Button type="submit">Filtrar</Button>
        <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
      </Stack>
    </form>
  );
};

export default FrmReportDay;
